module.exports = __webpack_public_path__ + "static/img/patho-otodectes-item-eIWytimq.75051d7b.png";